import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { AuthModal } from "./components/AuthModal";
import { AccountPage } from "./pages/AccountPage";
import { AlipayBridgePage } from "./pages/AlipayBridgePage";
import { ArtworksPage } from "./pages/ArtworksPage";
import { AuthResultPage } from "./pages/AuthResultPage";
import { GeneratePage } from "./pages/GeneratePage";
import { LegalPage } from "./pages/LegalPage";
import { PaymentResultPage } from "./pages/PaymentResultPage";
import { PricingPage } from "./pages/PricingPage";

export function App() {
  return (
    <>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/generate" element={<GeneratePage />} />
          <Route path="/artworks" element={<ArtworksPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/account" element={<AccountPage />} />
        </Route>
        <Route path="/auth/result" element={<AuthResultPage />} />
        <Route path="/payment/alipay" element={<AlipayBridgePage />} />
        <Route path="/payment/result" element={<PaymentResultPage />} />
        <Route path="/terms" element={<LegalPage kind="terms" />} />
        <Route path="/privacy" element={<LegalPage kind="privacy" />} />
        <Route path="*" element={<Navigate to="/generate" replace />} />
      </Routes>
      <AuthModal />
    </>
  );
}
